// log-pile for the browser: window errors and unhandled rejections become
// captures, every API call leaves a breadcrumb (see api/index.ts), and the
// signed-in user is attached (providers/authProvider.tsx). Sent as beacons
// to log-pile's /ingest with this site's public key; without a key (e.g. a
// fresh .env.local) captures print to the console instead.
import {
  beaconTransport,
  consoleTransport,
  createLogPile,
  installBrowserHandlers,
} from "../../shared-utils/logPile";

const url = import.meta.env.VITE_LOG_PILE_URL;
const key = import.meta.env.VITE_LOG_PILE_KEY;
const mode =
  import.meta.env.VITE_LOG_PILE_TRANSPORT === "fetch" ? "fetch" : "beacon";

export const logPile = createLogPile({
  source: "todoit-website",
  runtime: "browser",
  env: import.meta.env.VITE_STAGE || "unknown",
  release: __APP_VERSION__,
  transport:
    url && key
      ? beaconTransport({ url: `${url}/ingest`, key, mode })
      : consoleTransport(),
});

installBrowserHandlers(logPile);
logPile.reset({ location: window.location.href });
